module.exports = __webpack_public_path__ + "static/media/check-yourself.e33fed47.png";